import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.session()
      .then((data) => {
        if (data.authenticated) setUser({ username: data.username, fullName: data.full_name });
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (username, password) => {
    const data = await api.login(username, password);
    setUser({ username: data.username, fullName: data.full_name });
  };

  const logout = async () => {
    await api.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
